import React from "react";

export default function TitleComponent({ children }) {
    return <h1 className="title-style">{children}</h1>;
}
